
<button  mat-button  (click)="onLogout()">Logout of everything</button>
<button  mat-button  (click)="onCancel()">Cancel</button>
